import { internalGetCookie } from "./cookies";
import {redirectAfterRegistration} from "./session";

export const isLoggedIn = () =>
  internalGetCookie('AuthorizationToken');

if (isLoggedIn()) {
  redirectAfterRegistration();
}